import React from "react";
import "./index.css";

interface imageUploaderProps {
  className?: string;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  name: string;
  id: string;
  label?: string;
  readOnly?: boolean;
  required?: boolean;
  placeHolder?: string;
  formData: any;
}

export const BImageUploader: React.FC<imageUploaderProps> = ({
  className,
  label,
  setFormData,
  name,
  id,
  readOnly,
  required,
  placeHolder,
  formData
}) => {
  const imageHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
    let files = event.target.files;
    let reader = new FileReader();
    if (files) {
      reader.readAsDataURL(files[0]);
    }
    reader.onload = e => {
      if (e.target && e.target.result) {
        setFormData({ ...formData, [event.target.name]: e.target.result });
      }
    };
  };
  return (
    <div className={`${className} w-full`}>
      <label className="text-sm text-secondary ml-2" htmlFor={name}>
        {label}
      </label>

      <div className="flex justify-start w-full">
        <div className="rounded-lg shadow-xl bg-gray-50">
          <div className="m-4">
            <div className="flex items-center justify-center w-full">
              <label className="flex flex-col w-full h-32 border-4 border-dashed hover:bg-gray-100 hover:border-gray-300">
                {formData[name] &&
                  <img
                    src={formData[name]}
                    alt="b2blogo"
                    className="w-auto h-24"
                  />}
                {!formData[name] &&
                  <div className="flex flex-col items-center justify-center pt-7">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-12 h-12 text-gray-400 group-hover:text-gray-600"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <p className="pt-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600">
                      Select a photo
                    </p>
                  </div>}

                <input
                  type="file"
                  onChange={e => {
                    imageHandler(e);
                  }}
                  placeholder={placeHolder}
                  id={id}
                  name={name}
                  readOnly={readOnly}
                  required={required}
                  className="opacity-0"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
